import Select from "react-select";
import { sortAlphabetically } from "../helper/formatters";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { fetchConversions } from "../../../store/slices/admin/conversions";

// const sortedConversions = sortAlphabetically(conversions, "label");

type Props = {
	value: Array<string>;
	brandId: string,
	isEdit: boolean,
	updateConfig: Function;
};

type Option = {
	value: string;
	label: string;
};

const GoalConversionType = (props: Props) => {
	const conversions = useSelector((state: any) => state.conversions.cellId ? sortAlphabetically([...state.conversions.data[1]], "label") : []);
	const isLoading = useSelector((state: any) => state.conversions ? state.conversions.isLoading : false);
	const [selectedConversions, setSelectedConversions]: [Array<Option>, Function] = useState([]);

	const dispatch = useDispatch();
	
	const getTypes = useCallback((value: Array<string>) => {
		const selectedConversions: Array<Option> = conversions.filter(
			(conversion: Option) => value.includes(conversion.value)
		);

		return selectedConversions;
	}, [conversions]);
	
	/* eslint-disable react-hooks/exhaustive-deps */
	useEffect(() => {
		dispatch(fetchConversions(props.brandId, props.value || [], true, 1));
	}, []);
	
	useEffect(() => {
		if (props.isEdit && props.value && selectedConversions && selectedConversions.length === 0 && conversions.length > 0) {
			setSelectedConversions(getTypes(props.value));
			// props.updateConfig(["conversions"], prop);
		}
	}, [conversions]);
	

	const handleChange = (options: Array<Option>) => {
		setSelectedConversions(options);
		props.updateConfig(["conversions"], options ? options.map((option) => option.value) : []);
	};

	return (
		<div className="config-item__selects">
			<div className="form-group">
				<label htmlFor="conversionType">Conversion:</label>
				<Select
					id="conversionType"
					className="basic-single"
					classNamePrefix="so-select-metric-type"
					isSearchable={true}
					isMulti={true}
					isLoading={isLoading}
					value={selectedConversions}
					options={conversions}
					onChange={(options) => handleChange(options as Array<Option>)}
					menuPortalTarget={document.body}
					styles={{
						menuPortal: (base) => ({ ...base, zIndex: 9999 }),
					}}
				/>
			</div>
		</div>
	);
};

export default GoalConversionType;
